/**
 * D331: Trimmings, the currency decorations cost. Earned only from what the game already gives:
 * the daily gift, all of a day's orders sent, a tapped visitor or lucky find, a weekly event won.
 * Kept for good, never sold, and never spent on anything that earns.
 */
import type { IdleWorldState } from './state.ts';

/** Trimmings to spend. 0 on a world that has earned none. */
export function idleTrimmings(state: IdleWorldState): number {
  return state.permanent.trimmings ?? 0;
}

/** Add `n` Trimmings. The same state when `n` is 0. */
export function idleEarnTrimmings(state: IdleWorldState, n: number): IdleWorldState {
  if (n <= 0) return state;
  return {
    ...state,
    permanent: { ...state.permanent, trimmings: idleTrimmings(state) + n },
  };
}
